import PropTypes from "prop-types";
import React from "react";
import styles from "./feeds-seo-size-guide.css";

function FeedsSeoSizeGuide({ sizingChart }) {
    function renderTable(table, tableIndex) {
        return (
            <>
                <h3>{table.title}</h3>
                <table className={styles.sizeGuideTable}>
                    <tbody>
                        {table.rows.map((row, rowIndex) => (
                            <tr key={tableIndex + "-" + rowIndex}>
                                {row.map((column, colIndex) =>
                                    rowIndex === 0 ? (
                                        <th
                                            key={tableIndex + "-" + rowIndex + "-" + colIndex}
                                            className={styles.sizeGuideHeading}
                                        >
                                            {column}
                                        </th>
                                    ) : (
                                        <td
                                            key={tableIndex + "-" + rowIndex + "-" + colIndex}
                                            className={styles.sizeGuideCell}
                                        >
                                            {column}
                                        </td>
                                    )
                                )}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </>
        );
    }

    let title = null;
    if (sizingChart.title) {
        title = <h3>{sizingChart.title}</h3>;
    }

    let body = null;
    if (sizingChart.body) {
        body = <div dangerouslySetInnerHTML={{ __html: sizingChart.body }} />;
    }

    let tables = null;
    if (sizingChart.tables.length > 0) {
        tables = sizingChart.tables.map((table, tableIndex) => {
            if (table.rows.length > 0) {
                return (
                    <div key={tableIndex} className={styles.sizeGuideContainer}>
                        {renderTable(table, tableIndex)}
                    </div>
                );
            }
        });
    }

    if (title || body || tables) {
        return (
            <div className={styles.sizeGuide}>
                {title}
                {body}
                {tables}
            </div>
        );
    }

    return null;
}

FeedsSeoSizeGuide.propTypes = {
    sizingChart: PropTypes.shape({
        title: PropTypes.string,
        body: PropTypes.string,
        tables: PropTypes.arrayOf(
            PropTypes.shape({
                title: PropTypes.string,
                rows: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)),
            })
        ),
    }),
};

export default FeedsSeoSizeGuide;
